import Vue from 'vue'
import { cidade as routing } from '../util/routes'

export default {
  state: {
    cidade: {},
    cidades: [],
    paginateCidades: {
      data: []
    },
    cidadePage: 1,
    cidadeFilter: ''
  },
  mutations: {
    setCidade: (state, payload) => {
      state.cidade = payload
    },
    setCidades: (state, payload) => {
      state.cidades = payload
    },
    setPaginateCidades: (state, payload) => {
      state.paginateCidades = payload
    },
    setCidadePage: (state, payload = 1) => {
      state.cidadePage = payload
    },
    setCidadeFilter: (state, payload = '') => {
      state.cidadeFilter = payload
    }
  },
  actions: {
    async getPaginateCidades ({ commit, state }, payload) {
      commit('setPaginateCidades', {
        data: []
      })
      const { data } = await Vue.axios.get(`${routing}`, {
        headers: {
          page: state.cidadePage,
          filter: state.cidadeFilter
        }
      })
      commit('setPaginateCidades', data)
    },
    async getCidades ({ commit }, payload) {
      commit('setCidades', [])
      const { data } = await Vue.axios.get(`${routing}`, {
        headers: {
          limit: 0,
          ...payload
        }
      })
      commit('setCidades', data)
    },
    async getCidade ({ commit }, { id }) {
      const { data } = await Vue.axios.get(`${routing}/${id}`)
      commit('setCidade', data)
    },
    async postSaveCidade ({ state }) {
      const { cidade } = state
      if (cidade.id) {
        return Vue.axios.put(`${routing}/${cidade.id}`, cidade)
      }
      return Vue.axios.post(`${routing}`, cidade)
    },
    async deleteCidade ({ state }) {
      const { cidade } = state
      return Vue.axios.delete(`${routing}/${cidade.id}`)
    }
  },
  getters: {
    cidade: ({ cidade }) => cidade,
    cidadePage: ({ cidadePage }) => cidadePage,
    cidadeFilter: ({ cidadeFilter }) => cidadeFilter,
    cidades: ({ cidades }) => cidades,
    paginateCidades: ({ paginateCidades }) => paginateCidades
  }
}
